module.exports = __webpack_public_path__ + "img/shakeys_menu_side1.ed5ba01b.jpg";